import api from '@/api'

export function obtainToken (user) {
  return api.post(`/auth/api-token/`, user)
}
